import { createI18n } from 'vue-i18n'
import { watch } from 'vue'
import { Chart } from 'chart.js'
import messages from 'src/i18n/i18n.js'
import { numberLocale } from 'src/utils/displayLabels'

export default ({ app }) => {
  const i18n = createI18n({
    legacy: false,
    messages
  })

  app.use(i18n)

  const applyChartLocale = (locale) => {
    Chart.defaults.locale = numberLocale(locale)
  }
  applyChartLocale(i18n.global.locale.value)
  watch(() => i18n.global.locale.value, applyChartLocale)
}
